import Switch from '~/shared/components/Switch';
import Typography from '~/shared/components/Typography';
import { toaster } from '~/shared/utils/toaster';

interface OptimisticToggleSwitchProps {
  switchState: boolean;
  onSwitchClick: (newState: boolean) => void;
  isPending: boolean;
  isUserReadOnly?: boolean;
}

export default function OptimisticToggleSwitch({
  switchState,
  onSwitchClick,
  isPending,
  isUserReadOnly = false,
}: OptimisticToggleSwitchProps) {
  const handleSwitchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isUserReadOnly) {
      toaster({
        title: 'Action failed',
        message: "You don't have permissions to perform this action",
        variant: 'error',
      });
      return;
    }
    const newCheckedState = e.target.checked;
    onSwitchClick(newCheckedState);
  };

  return (
    <div className="flex items-center gap-2">
      <Switch
        checked={switchState}
        onChange={handleSwitchChange}
        disabled={isUserReadOnly || isPending}
      />
      <div>
        <Typography variant="p3" color="text-blue-600" className="font-medium">
          {switchState ? 'On' : 'Off'}
        </Typography>
      </div>
    </div>
  );
}
